/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export type IAPI73410ReqParamsObjMapValueObj = {};
    
  
    
export interface IAPI73410ReqParamsObj {
  
  /** String */
  mapKey?: IAPI73410ReqParamsObjMapKeyObj;
  
  /** Object */
  mapValue?: IAPI73410ReqParamsObjMapValueObj;
  
};
    
  
    
export interface IAPI73410ResFromObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
};
    
  
    
export interface IAPI73410ResToObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
};
    
  
    
export interface IAPI73410ResRecordsItemActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: boolean;
  
};
    
  
    
export interface IAPI73410ResRecordsItem {
  
  /**  */
  sendTime?: string;
  
  /**  */
  content?: string;
  
  /**  */
  source?: string;
  
  /** ActionResp */
  actions?: IAPI73410ResRecordsItemActionsItem[];
  
};
    
  



export interface API73410Req {
  
  /** 场景：默认为default */
  scenes: string;
  /** 子场景:业务带 */
  subScenes?: string;
  /** 是否带历史记录：默认false */
  withHistory?: string;
  /** 会话标识Id */
  sessionToken: string;
  /** 场景：默认为default */
  scenes?: string;
  /** 子场景:业务带 */
  subScenes?: string;
  /** 是否带历史记录：默认false */
  withHistory?: boolean;
  /** 会话标识Id */
  sessionToken?: string;
  /** (该参数为map) */
  params?: IAPI73410ReqParamsObj;
};



export interface API73410Res {
  /**   */
  sessionToken?: string;
  /** HeadImgResp  */
  from?: IAPI73410ResFromObj;
  /** HeadImgResp  */
  to?: IAPI73410ResToObj;
  /** ChatRecordResp  */
  records?: IAPI73410ResRecordsItem[];
  
};


// 接口函数 73410 重置会话

export interface IUsePostAPI73410Return {
  /** 重置会话: 接口请求状态 */
  isAPI73410Loading: boolean;
  /** 重置会话: 接口请求返回数据 */
  dataAPI73410: API73410Res;
  /**  重置会话: 接口数据请求方法 */
  fetchAPI73410Data: (inputs: API73410Req, config?: YWRequestConfig) => Promise<API73410Res>;
  /** 重置会话: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI73410 = ():IUsePostAPI73410Return => {
  let isMount = true;
  const [isAPI73410Loading, setIsAPI73410Loading] = useState(false);
  const [dataAPI73410, setDataAPI73410] = useState<API73410Res>({} as API73410Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/session/reset`;

  const fetchAPI73410Data = async (inputs: API73410Req, config?: YWRequestConfig): Promise<API73410Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API73410Req>) || {}) as API73410Req;
    
  
    if ( isMount ) {
      setIsAPI73410Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API73410Res>(`${basePath}/yoaichat-web/chat/session/reset`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI73410(res || {} as API73410Res);
        setIsAPI73410Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI73410Loading(false);
      }
      return false as unknown as API73410Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI73410Loading,
    dataAPI73410,
    fetchAPI73410Data,
    requestUrl,
  }
}

